// "Built on Emergent", kept tiny: bottom right on the loading screen, and at the right end of the city's live ticker.
const BASE = "flex shrink-0 items-center gap-1 whitespace-nowrap text-[8px] font-medium leading-none text-slate-500 opacity-70 transition-opacity hover:opacity-100";

export function EmergentBadge({ inline = false }) {
  return (
    <a href="https://app.emergent.sh/?utm_source=emergent-badge" target="_blank" rel="noopener noreferrer"
      className={inline ? `${BASE} h-full border-l border-x-line px-2` : `${BASE} absolute bottom-1.5 right-2 z-10`}
      data-testid={inline ? "built-on-emergent-ticker" : "built-on-emergent"}>
      Built on <img src="/brands/emergent.svg" alt="Emergent" className="h-[7px] w-auto" />
    </a>
  );
}
